window.addEventListener("scroll", () => {
    whenScroll();
});
whenScroll();

let offset = 0;

function resize() {
    offset = innerHeight / 3;
}

window.addEventListener("resize", resize);
resize();

/**
 * スクロール時にページ最下部かどうかをチェックし、クラスを追加/削除する関数
 * @example
 * // スクロールイベントで呼び出す
 * window.addEventListener("scroll", whenScroll);
 */
export function whenScroll() {
    if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - offset
    ) {
        document.body.classList.add("endoffooter");
    } else {
        document.body.classList.remove("endoffooter");
    }
}
